import { Product } from "@/types/product";

export const meetingRoomProducts: Product[] = [
  {
    id: "rxt-4-d",
    groupId: "meeting-room",
    name: "RXT-4-D",
    description: "The RXT-4-D is the world's first 4\" ReAX™ JavaScript based Touch Panel/Control System with integrated Dante™ audio networking. It features a beautiful 480 x 480 1:1 aspect ratio touch screen with 160° viewing angle and customizable room status lighting in virtually any color combination.\n\nDesigned for professional integration, the RXT-4-D mounts easily in a 2-gang or European style electrical box. Its powerful 2D/3D graphics engine with 1080p H.264 streaming decoder provides an exceptional user experience for complex graphics and video content. The integrated Dante™ audio networking offers advanced audio routing capabilities for sophisticated AV environments.\n\nThe RXT-4-D enhances user interaction with features including a 1-watt speaker, stereo digital microphone, proximity sensor, and ambient light sensor. Its internal web server allows control from remote devices like smartphones and computers. Powered by the ReAX™ Core Engine with JavaScript programming, the RXT-4-D delivers a powerful 'all-in-one' solution for presentation and automation needs in conference rooms, educational facilities, hospitality venues, and more.",
    features: [
      "4\" 480x480 Resolution Touch Screen",
      "Dante™ Audio Network Integration",
      "ReAX™ JavaScript Engine",
      "PoE Powered",
      "Dual Core Processor running Linux™",
      "Multiple Control Ports (RS-232, IR, I/O, Relay)",
      "RGB LED Ring for Room Status",
      "1GB DDR3 Memory",
      "8GB Storage",
      "Speaker (1 Watt)",
      "Stereo Digital Microphones",
      "Ambient Light Sensor",
      "Proximity Sensor",
      "10/100 LAN PoE",
      "QR Smart Room Logging and Scheduling",
      "2-Gang or European Style Mounting"
    ],
    specifications: [
      "Display: 4\" 480x480 Resolution",
      "Brightness: 420 nits",
      "Processor: Dual Core @ 1.0GHz",
      "Operating System: Linux™",
      "Memory: 1GB DDR3",
      "Storage: 8GB",
      "Communications: 10/100 LAN PoE (IEEE 802.3af)",
      "Audio: Dante™ Audio Network Interface, Speaker (1 Watt), Stereo Digital Microphones",
      "Control Ports: 2 RS-232, 2 IR, 2 Digital I/O, 2 Relay",
      "Sensors: Ambient Light Sensor, Proximity Sensor",
      "Status: RGB LED Ring for Room Usage Status or Ambiance Lighting",
      "Mounting: In-Wall (2-Gang or European Style)",
      "Dimensions (HxWxD): 91mm x 91mm x 13mm (3.58\" x 3.58\" x 0.51\")"
    ],
    images: [
      "/lovable-uploads/ba49821c-da0f-4aec-abd4-65fbfe07bea7.png",
      "/lovable-uploads/46a9d131-1549-45f6-a86c-0ab64b5901d4.png",
      "/lovable-uploads/2716292a-3111-4dd7-afb4-e410fb401e5c.png"
    ],
    image: "/lovable-uploads/ba49821c-da0f-4aec-abd4-65fbfe07bea7.png",
    slug: "rxt-4-d"
  },
  {
    id: "rxt-6-d",
    groupId: "meeting-room",
    name: "RXT-6-D",
    description: "The RXT-6D is a 6\" desktop touch panel with a ReAX™ JavaScript based control system and SmartSpeak™. Ideal for conference rooms, educational facilities, hospitality, digital signage and more. The RXT-6D has a beautiful 1440 x 720 1:1 aspect ratio touch screen with 160° viewing.\n\nSmartSpeak™ takes microphone technology to another level with a Dante/AES67 beamforming microphone with auto gain, noise cancelation, feedback suppression, and anti-tap. Camera tracking using Aurora's WordGate™ technology is like no other. It uses AI to detect speech intelligibility in over 100 languages along with Sound Pressure Levels (SPL) to trigger the camera presets. This eliminates false triggering caused by clapping, coughing, and other unintended noises.\n\nThe 2D/3D graphics engine with 4K30 H.264 & RTSP streaming decoder provides a powerful solution for complex graphics and video, ensuring an enhanced user experience. To further enhance the experience, the RXT-6D has a 4-watt powered speaker, proximity sensor, & ambient light sensor. The internal web server allows control from remote devices like cell phones and computers.\n\nThe RXT-6D is a powerful 'all-in-one' solution for your presentation and automation needs. Core Studio tool is available free of charge for code and interface creation.",
    features: [
      "6\" 1440x720 Resolution Touch Screen",
      "500 nits Brightness",
      "Six Core 2.0GHz Processor",
      "800MHz Audio DSP",
      "ReAX™ Control Engine",
      "Server-Side JavaScript",
      "SmartSpeak™ Beamforming Microphones",
      "WordGate™ Camera Tracking with AI",
      "Dante/AES67 Audio Network",
      "Noise Cancelation & Feedback Suppression",
      "Auto Gain & Mix-Minus",
      "4-Watt Speaker & 3.5mm Headphone Out",
      "RTSP Real-time Camera Previewing",
      "Ambient Light & Proximity Sensors",
      "Front and Rear RGB LED Indicators",
      "NFC Support",
      "1G LAN PoE+",
      "Voting & Booking Capabilities",
      "Raise Hand Function",
      "Full Room Automation",
      "Assistive Hearing & Translation Talkback",
      "Wireless Remote Web Control",
      "Fully Customizable"
    ],
    specifications: [
      "Display: 6\" 1440x720 Resolution, 1:1 Aspect Ratio",
      "Brightness: 500 nits",
      "Viewing Angle: 160°",
      "Processor: Six Core @ 2.0GHz",
      "Audio DSP: 800MHz",
      "Operating System: Linux™ with ReAX™",
      "Programming: Server-Side JavaScript",
      "Audio: Dante/AES67 Network, SmartSpeak™ Beamforming Microphones, 4-Watt Speaker, 3.5mm Headphone Output",
      "Audio Features: Noise Cancelation, Feedback Suppression, Auto Gain, Mix-Minus",
      "Video: 4K30 H.264 & RTSP Streaming Decoder",
      "Camera Tracking: WordGate™ AI-powered (100+ languages)",
      "Network: 1G LAN PoE+ (IEEE 802.3at)",
      "Sensors: Ambient Light Sensor, Proximity Sensor",
      "Status Indicators: Front and Rear RGB LED",
      "NFC: Supported",
      "Control: RS-232, IR, Digital I/O, Relay",
      "Mounting: Desktop Form Factor",
      "Power: PoE+ or External Power Supply"
    ],
    image: "/lovable-uploads/rxt-6d-front.png",
    images: [
      "/lovable-uploads/rxt-6d-front.png"
    ],
    slug: "rxt-6-d"
  },
  {
    id: "rxt-4-dv",
    groupId: "meeting-room",
    name: "RXT-4-DV",
    description: "About\nThe RXT-4DV is a 4\" desktop touch panel with a ReAX™ JavaScript based control system. Ideal for conference rooms, educational facilities, hospitality, digital signage and more. The RXT‑4DV has a beautiful 720 x 720 1:1 aspect ratio touch screen with 160° viewing. It is also designed to work as a Dante™ beam forming microphone with advanced hardware for feedback suppression, auto gain, & noise cancelation. The built in 4-Watt speaker allows the creation of a speaker array when multiple units are used.\n\nTo further the capability of this all-in-one unit is the integrated VPX 1Gbps 4k60 AV over IP transmitter. On the side is a USB-C and mini-HDMI input connector. On the rear is a USB-C power pass-through connector which can move 100 watts to the side input connector for laptop charging. There is also a USB-C display output connector on the rear for secondary screen usage.\n\nThe 2D/3D graphics engine with 4K H.264 streaming decoder provides a powerful solution for complex graphics and video, ensuring an enhanced user experience.\n\nTo further enhance the experience, the RXT‑4DV has a 4-watt powered speaker, proximity sensor, & ambient light sensor. The internal web server allows control from remote devices like cell phones and computers.\n\nThe RXT-4DV is a powerful 'all-in-one' solution for your presentation and automation needs. Core Studio tool is available free of charge for code and interface creation.\n\nVoting\nBooking\nName Placeholder\nRaise Hand Function\nFull Room Automation\nWireless Microphone via Bluetooth\nAssistive Hearing & Translation Talkback\nWireless Remote Web Control\nContent Distribution\nFully Customizable",
    features: [
      "4\" 480x480 Resolution Touch Screen",
      "Desktop Form Factor with Adjustable Viewing Angle",
      "ReAX™ JavaScript Core Engine",
      "Dante™ Audio Network Integration",
      "Built-in Speaker and Stereo Microphones",
      "Customizable RGB Status Lighting",
      "HDMI and USB-C Connectivity",
      "Multiple Control Ports",
      "Web Server for Remote Access",
      "QR Smart Room Logging and Scheduling",
      "PoE Powered"
    ],
    specifications: [
      "Display: 4\" 480x480 Resolution, 1:1 Aspect Ratio",
      "Brightness: 420 nits",
      "Viewing Angle: 160°",
      "Processor: Dual Core @ 1.0GHz",
      "Operating System: Linux™",
      "Memory: 1GB DDR3",
      "Storage: 8GB",
      "Audio: Dante™ Audio Network, Speaker (1 Watt), Stereo Digital Microphones",
      "Video: HDMI Input/Output, USB-C",
      "Control Ports: RS-232, IR, Digital I/O, Relay",
      "Network: 10/100 Ethernet, PoE (IEEE 802.3af)",
      "Power: PoE or External Power Supply",
      "Dimensions: Desktop Form Factor with Adjustable Stand"
    ],
    image: "/lovable-uploads/ed496011-628e-48b8-92f6-f599f498078a.png",
    slug: "rxt-4-dv"
  },
  {
    id: "bx-25d",
    groupId: "meeting-room",
    name: "BX-25D",
    description: "The BX-25D is a 25-Watt Dante/AES67 4.5\" woofer speaker which allows lower fuller frequencies to be added to any room. Primarily designed for the Aurora ReAX Room to complement the RXT-4D/DV (4\" Touch Controller with Dante/AES67 Beamforming Microphone & Speaker). The small form factor and light weight allows it to be mounted under the table with the included mounting brackets or just about anywhere. The mounting bracket has rubber grommets built in to help isolate vibration into the table. It also features an OLED for IP Address and other status information for better setup and serviceability.",
    features: [
      "4.5\" Woofer 60Hz-2000Hz",
      "25-Watt PoE+ Amplifier",
      "Dante/AES67",
      "OLED Display with Selection Buttons for Status Information",
      "Power/Status Indicators",
      "Internal Web Server for Remote Diagnostics and Settings"
    ],
    images: [
      "/lovable-uploads/e364f336-a3da-4a3c-95f8-1ee88392550b.png",
      "/lovable-uploads/421f9801-65ca-4dc4-8b3b-7ba81e7e9519.png"
    ],
    image: "/lovable-uploads/e364f336-a3da-4a3c-95f8-1ee88392550b.png",
    slug: "bx-25d"
  }
];
